import React from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
    Container,
    Grid,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    Collapse,
    Select,
    MenuItem,
    Dialog,
    DialogContent,
    RadioGroup,
    Radio,
    FormControlLabel,
    TablePagination,
    Stack,
    Checkbox,
    TextField
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
    AddCircle,
    ExitToApp,
    ShareOutlined,
    Storefront,
    Twitter,
    Upload,
    WarehouseOutlined,
} from "@mui/icons-material";
import {
    get_brand,
    get_inventory,
    get_type
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation } from "react-router-dom";

export default function Inventory() {
    const classes = useStyles();
    const navigate = useNavigate();
    const location = useLocation();

    const [brand, setBrand] = React.useState('all');

    const handleChangeBrand = (event) => {
        setBrand(event.target.value);
    };

    const [type, setType] = React.useState('all');

    const handleChangeType = (event) => {
        setType(event.target.value);
    };

    const [allData, setAllData] = React.useState([]);
    const [searchKey, setSearchKey] = React.useState("");

    const handleSearch = (event) => {
        setSearchKey(event.target.value);
        var _data = searchData(allData, event.target.value);
        setInventory(_data);
        setPageNum(0);
        setTotalList(_data.length);
    };

    const [loading, setLoading] = React.useState(false)
    const [totalList, setTotalList] = React.useState(1);
    const [pageNum, setPageNum] = React.useState(0);

    const [inventory, setInventory] = React.useState(null);
    const [brandList, setBrandList] = React.useState(null);
    const [typeList, setTypeList] = React.useState(null);

    const getData = () => {
        setLoading(true);
        get_inventory({
            page: pageNum + 1,
            brand: brand,
            type: type,
        }).then((json) => {
            setLoading(false);
            setAllData(json.data);
            var _data = searchData(json.data, searchKey);
            setInventory(_data);
            setTotalList(_data.length);
        });
    };

    const getDataBrand = () => {

        setLoading(true);

        setPageNum(0)
        get_inventory({
            page: 1,
            brand: brand,
            type: type,
        }).then((json) => {
            setLoading(false);
            setAllData(json.data);
            var _data = searchData(json.data, searchKey);
            setInventory(_data);
            setTotalList(_data.length);
        });
    };

    const getBrand = () => {
        get_brand({}).then((resBrand) => {
            setBrandList(resBrand.data);
        });
        get_type({}).then((resType) => {
            setTypeList(resType.data);
        });
    };

    React.useEffect(() => {
        getBrand();
    }, []);

    // React.useEffect(() => {
    //     getData();
    // }, [pageNum]);

    React.useEffect(() => {
        getDataBrand();
    }, [brand, type]);

    const handleChangePage = (e, ispage) => {
        setPageNum(ispage);
        // getData();
    };

    const searchData = (data, searchKey) => {
        console.log(data, 'data');
        var _data = [];
        if (searchKey != "") {
            for (var i = 0; i < data.length; i++) {
                console.log(data[i].itemname.toUpperCase(), 'itemname');
                if (data[i].itemname.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
                    || data[i].displayname.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
                    || data[i].externalid.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
                    || data[i].internalid.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
                ) {
                    _data.push(data[i]);
                } else if (data[i].children && data[i].children.length) {
                    for (var j = 0; j < data[i].children.length; j++) {
                        if (data[i].children[j].itemname.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
                            || data[i].children[j].displayname.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
                            || data[i].children[j].externalid.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
                            || data[i].children[j].internalid.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
                            || data[i].children[j].size.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
                            || data[i].children[j].colorname.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
                        ) {
                            _data.push(data[i]);
                        }
                    }
                }
            }

        } else {
            _data = [...data];
        }

        return _data;
    }

    return (
        <React.Fragment>
            {loading ?
                <div style={{ margin: 'auto' }}>
                    <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
                </div>
                :
                <Navbar2
                    children={
                        <Section pd="2rem">
                            <div>
                                <div className={classes.theFlexHeader}>
                                    {/* <div className={classes.theHeaderSelect}>
                                        <FormInput
                                            // label="Username"
                                            textLabelColor="#000"
                                            // placeholder="Username"
                                            // name="username"
                                            bold="600"
                                            border="0"
                                            size="24px"
                                            value={location.pathname.replace(/[^A-Za-z]+/g, "")}
                                            select
                                            onChange={handleHeader}
                                        >
                                            <MenuItem value="sale">Sale Order</MenuItem>
                                            <MenuItem value="invoice">Invoice</MenuItem>
                                        </FormInput>
                                    </div> */}
                                    <Paragraph color="#1A5386" bold="600" size="24px">
                                        Inventory
                                    </Paragraph>


                                    <div className={classes.theFlexBtn} style={{ marginBottom: "0" }}>
                                        {/* <a
                                            className={classes.theCustomActionBtn}
                                        // onClick={() => handleOpenStockMove()}
                                        >
                                            <AddCircle sx={{ color: "#1A5386" }} />
                                            <Paragraph margin="0 0 0 .4rem">Create New Order</Paragraph>
                                        </a> */}
                                        {/* <a
                                            className={classes.theCustomActionBtn_}
                                        // onClick={() => handleOpenStockMove()}
                                        >
                                            <ExitToApp sx={{ color: "#1A5386" }} />
                                            <Paragraph margin="0 0 0 .4rem">Export</Paragraph>
                                        </a> */}
                                    </div>
                                </div>
                                <div
                                    style={{
                                        borderBottom: "2px solid #707070",
                                        padding: ".2rem 0",
                                    }}
                                />
                                <br />

                                <div className={classes.theFlexAction}>
                                    <div className={classes.theWx} style={{ margin: "0 20px 0 0" }}>
                                        <FormInputNoLabel
                                            placeholder="Search"
                                            border="1px solid #d7d7d7"
                                            br="6px"
                                            onChange={handleSearch}
                                            value={searchKey}
                                        />
                                    </div>
                                    <div className={classes.theWx} style={{ margin: "0 20px 0 0" }}>
                                        <TextField
                                            placeholder="Payment Type"
                                            border="1px solid #d7d7d7"
                                            label="Brand"
                                            br="6px"
                                            style={{
                                                width: "100%"
                                            }}
                                            onChange={handleChangeBrand}
                                            value={brand}
                                            select
                                        >
                                            <MenuItem value="all">All</MenuItem>
                                            {brandList != null && brandList.map((res) =>
                                                <MenuItem value={res.brand}>{res.brand}</MenuItem>
                                            )}
                                        </TextField>
                                    </div>
                                    <div className={classes.theWx} style={{ margin: "0 20px 0 0" }}>
                                        <TextField
                                            placeholder="Payment Type"
                                            border="1px solid #d7d7d7"
                                            br="6px"
                                            label="Type"
                                            style={{
                                                width: "100%"
                                            }}
                                            onChange={handleChangeType}
                                            value={type}
                                            select
                                        >
                                            <MenuItem value="all">All</MenuItem>
                                            {typeList != null && typeList.map((res) =>
                                                <MenuItem value={res.type}>{res.type}</MenuItem>
                                            )}
                                        </TextField>
                                    </div>
                                    {/* <div className={classes.theWx}>
                                    <div className={classes.theFlex_}>
                                        <FormInputSelect>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={sort}
                                                // defaultValue={sort}
                                                onChange={handleChangeSort}
                                            >
                                                <MenuItem value="0" style={{ color: "#000" }}>
                                                    All Payment Type
                                                </MenuItem>
                                                <MenuItem value="1" style={{ color: "#000" }}>
                                                    Paid
                                                </MenuItem>
                                                <MenuItem value="2" style={{ color: "#000" }}>
                                                    On Hold
                                                </MenuItem>
                                                <MenuItem value="3" style={{ color: "#000" }}>
                                                    Cancelled
                                                </MenuItem>
                                            </Select>
                                        </FormInputSelect>
                                    </div>
                                </div> */}
                                </div>

                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <Card className={classes.theCard}>
                                            <TableContainer>
                                                <Table>
                                                    <TableHead style={{ backgroundColor: "#1A5386" }}>
                                                        <TableRow>
                                                            <TableCell style={{ borderRadius: "10px 0 0 10px" }} className={classes.theHeadTitle}>
                                                                Item Name
                                                            </TableCell>
                                                            {/* <TableCell className={classes.theHeadTitle}>
                                                                HS Code
                                                            </TableCell> */}
                                                            {/* <TableCell className={classes.theHeadTitle}>
                                                                Item Name
                                                            </TableCell> */}
                                                            <TableCell className={classes.theHeadTitle}>
                                                                Display Name
                                                            </TableCell>
                                                            <TableCell className={classes.theHeadTitle}>
                                                                Sales Description
                                                            </TableCell>
                                                            {/* <TableCell className={classes.theHeadTitle}>
                                                                Quantity Available
                                                            </TableCell> */}
                                                            <TableCell className={classes.theHeadTitle}>
                                                                Sale Unit
                                                            </TableCell>
                                                            <TableCell className={classes.theHeadTitle}>
                                                                Item Type
                                                            </TableCell>
                                                            <TableCell className={classes.theHeadTitle}>
                                                                Type
                                                            </TableCell>
                                                            <TableCell className={classes.theHeadTitle}>
                                                                Brand
                                                            </TableCell>
                                                            <TableCell style={{ borderRadius: "0 10px 10px 0" }} className={classes.theHeadTitle}>
                                                                Status
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {inventory != null &&
                                                            inventory.slice(pageNum * 10, pageNum * 10 + 10).map((item, index) => {

                                                                return (
                                                                    <TableRow>
                                                                        <a
                                                                            style={{ display: "contents" }}
                                                                        // href={`../inventorydetail/${item.item_id}`}
                                                                        >
                                                                            {/* <TableCell><Checkbox
                                                                                sx={{
                                                                                    color: "#1A5386",
                                                                                    '&.Mui-checked': {
                                                                                        color: "#1A5386",
                                                                                    },
                                                                                }} /></TableCell> */}
                                                                            {/* <TableCell style={{ textDecoration: "underline" }}
                                                                                onClick={() => navigate("/inventorydetail/" + item.item_id)}
                                                                            >
                                                                                {item.hscode != "" && item.hscode != null ? item.hscode : "-"}
                                                                            </TableCell> */}
                                                                            <TableCell
                                                                                className={classes.theUnderLineLabel}
                                                                                onClick={() => navigate("/inventorydetail/" + item.item_id)}
                                                                            >
                                                                                {item.itemname != "" && item.itemname != null ? item.itemname : "-"}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                onClick={() => navigate("/inventorydetail/" + item.item_id)}
                                                                            >
                                                                                {item.displayname != "" && item.displayname != null ? item.displayname : "-"}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                onClick={() => navigate("/inventorydetail/" + item.item_id)}
                                                                            >
                                                                                {item.salesdescription != "" && item.salesdescription != null ? item.salesdescription : "-"}
                                                                            </TableCell>
                                                                            {/* <TableCell
                                                                                onClick={() => navigate("/inventorydetail/" + item.item_id)}
                                                                            >
                                                                                {item.quantityavailable != "" && item.quantityavailable != null ? item.quantityavailable : "-"}
                                                                            </TableCell> */}
                                                                            <TableCell
                                                                                onClick={() => navigate("/inventorydetail/" + item.item_id)}
                                                                            >
                                                                                {item.saleunit != "" && item.saleunit != null ? item.saleunit : "-"}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                onClick={() => navigate("/inventorydetail/" + item.item_id)}
                                                                            >
                                                                                {item.itemtype != "" && item.itemtype != null ? item.itemtype : "-"}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                onClick={() => navigate("/inventorydetail/" + item.item_id)}
                                                                            >
                                                                                {item.type != "" && item.type != null ? item.type : "-"}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                onClick={() => navigate("/inventorydetail/" + item.item_id)}
                                                                            >
                                                                                {item.brand != "" && item.brand != null ? item.brand : "-"}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                onClick={() => navigate("/inventorydetail/" + item.item_id)}
                                                                            >
                                                                                {item.inactive == 0 ?
                                                                                    <Paragraph color="#707070">
                                                                                        Active
                                                                                    </Paragraph>
                                                                                    :
                                                                                    <Paragraph color="#C52626">
                                                                                        Inactive
                                                                                    </Paragraph>
                                                                                }
                                                                            </TableCell>
                                                                        </a>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                            <div style={{
                                                borderTop: "1px solid #707070",
                                                borderBottom: "1px solid #707070",
                                                margin: "1rem 0 0",
                                                cursor: "pointer",
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                alignItems: "flex-end",
                                            }}>
                                                <TablePagination
                                                    // variant="outlined"
                                                    color="primary"
                                                    page={pageNum}
                                                    onPageChange={handleChangePage}
                                                    count={totalList}
                                                    // defaultPage={pageList}
                                                    rowsPerPage={10}
                                                    rowsPerPageOptions={[10]}
                                                // count={10}
                                                />
                                            </div>
                                        </Card>
                                        <br />
                                        <br />
                                    </Grid>
                                </Grid>
                                <br />
                                <br />
                            </div>
                        </Section>
                    }
                />
            }
        </React.Fragment>
    );
}
